module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_fondo_blanco.478faf6a.png";